import { useState, useCallback } from 'react';

export function useToggle(initialState = false): [boolean, () => void] {
    const [state, setState] = useState(initialState);
    const toggle = useCallback((): void => setState(s => !s), []);
    return [state, toggle];
}
